import classNames from 'classnames'
import { Badge, PriceTag, StoreIcons } from 'baby-design'
import { PriceTagProps } from 'baby-design/components/PriceTag/PriceTag'
import { useWindowSize } from 'usehooks-ts'

import { BREAKPOINT_TABLET } from 'src/constants'
import { getPriceTagPropsFromPriceDetails } from 'src/utils/productHelpers'
import { RegItemMinimalCardDetailsProps } from '../RegItemMinimalCardDetails.types'
import css from '../RegItemMinimalCardDetails.styles.scss'

const ProductDetails: React.FC<RegItemMinimalCardDetailsProps> = ({
  regItem,
}: RegItemMinimalCardDetailsProps) => {
  const { width: windowWidth } = useWindowSize()
  const isMobile = windowWidth < BREAKPOINT_TABLET
  const { title } = regItem
  const wrapperClasses = classNames(
    css.RegItemMinimalCardDetails,
    css.ProductDetails
  )
  const storesIconsMap = (regItem.offers || []).map((offer) => ({
    name: offer.storeIconName,
  }))

  let priceTagProps: PriceTagProps = { currentPrice: regItem.price }
  if (regItem.priceDetails) {
    priceTagProps = getPriceTagPropsFromPriceDetails(regItem.priceDetails)
  }

  const shouldShowOutOfStock =
    regItem.offers?.length === 1 &&
    regItem.offers[0].storeDisplayName === 'Babylist' &&
    !regItem.isAvailableOnBabylist

  return (
    <div className={wrapperClasses} data-testid="ProductDetails">
      <div className={css.Title}>{title}</div>
      <StoreIcons
        size={isMobile ? 'small' : 'medium'}
        stores={storesIconsMap}
      />
      <PriceTag className={css.PriceTag} size="sm" {...priceTagProps} />
      {shouldShowOutOfStock && (
        <div>
          <Badge
            className={css.Badge}
            fill="gray"
            label="Out of stock"
            size={isMobile ? 'small' : 'medium'}
            variant="promo"
          />
        </div>
      )}
    </div>
  )
}

export default ProductDetails
